<template>
    <div id="blog">
        <div class="page-inner-wrapper position-relative white-bg">
            <div class="position-relative page-header bg-img-atr-fix ">
                <div class="position-absolute overlay overlay-bg-lightdark">
                    <div class="d-flex flex-row align-items-center justify-content-center">
                        <h1 class="white-color">Blog</h1>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="col-lg-12">
                    <div class="column-inner">
                        <div class="wrapper">
                            <div class="white-bg" style="width: 100%; height: 550px;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Footer from "../components/Footer";

    export default {
        name: "Blog",
        props: {
            webData: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                dataText: this.webData.blog
            }
        },
        components: {
            Footer
        }
    }
</script>

<style>
    #blog .page-inner-wrapper .page-header {
        background-image: url("../assets/photos/h3_blog_bg.jpg");
    }
    #blog .page-header .overlay .d-flex {
        height: 100%;
    }
</style>